
/* injects from baggage-loader */

'use strict';

import AboutController from './about.controller';
import AboutTemplate from './about.html';

export default class AboutComponent {
		constructor() {
				this.templateUrl = AboutTemplate;
				this.controller = AboutController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/about/about.component.js